import { produce } from "immer";
import { EditMode } from "./uiState";
export function animation_stopTransition(state) {
    return produce(state, draft => {
        draft.machineState.uiState.editMode = EditMode.EXECUTION;
        draft.machineState.animation.progress = 0;
    });
}
export function animation_setProgress(state, progress) {
    return produce(state, draft => {
        draft.machineState.animation.progress = progress;
    });
}
